// extracted by mini-css-extract-plugin
export var infoBlock = "InfoBlock-module--info-block--30c24";